export enum SelfAssessmentCta {
  DIAGNOSIS = 'DIAGNOSIS',
  DEPRESSION_THERAPISTS = 'DEPRESSION_THERAPISTS',
}
